import React, { Component } from 'react'
import InstanciaBasic from './InstanciaBasic.js'
import {RadioGroup, Radio} from 'react-radio-group';
import * as Constants from '../constants.js'

class InstanciaSiNo extends InstanciaBasic {
	constructor(props) {
    super(props);
		this.recalcularEstado = this.recalcularEstado.bind(this);
  }

	recalcularEstado(value) {
		let estadoActual = Constants.ID_ESTADO_APROBACION_SIN_COMPROBACION
		let opcionCorrespondiente = null
		if (this.props.atributo.extraParams.checks)
			opcionCorrespondiente = this.props.atributo.extraParams.checks.find(opcion => opcion.text == value)
		if (opcionCorrespondiente)
			estadoActual = opcionCorrespondiente.estado
		return estadoActual
	}

	render() {
      // VEC-3817: "No aplica" (estado SIN_COMPROBACION) es opcional por pregunta, y acotado
      // a preguntas Si/No. El backend devuelve 0/1 crudos (no boolean) para este flag, así
      // que hay que usar un chequeo truthy y no "!== false" (0 !== false es true en JS, por
      // tipos distintos). "undefined"/"null" (atributo sin este campo seteado, checklists
      // creados antes de este cambio, u otro contexto como safeFeedback) se trata como true
      // por compatibilidad.
      let permiteNoAplicaValor = this.props.atributo.permite_no_aplica;
      let permiteNoAplica = (permiteNoAplicaValor === undefined || permiteNoAplicaValor === null) ? true : !!permiteNoAplicaValor;
      let checks = this.props.atributo.extraParams.checks || [];
      // Review Copilot: Formulario Asociado reusa este mismo componente (INSTANCIAS_DICT[
      // ID_FORMULARIO_ASOCIADO].clase = InstanciaSiNo) pero está fuera del alcance de esta
      // opción. Si una pregunta Si/No se guardó con el flag apagado y luego se le cambió el
      // tipo a Formulario Asociado, ese false guardado no debe filtrar nada acá.
      if (!permiteNoAplica && this.props.atributo.tipoValor === Constants.ID_SINO) {
        checks = checks.filter(option => option.estado !== Constants.ID_ESTADO_APROBACION_SIN_COMPROBACION);
      }
      return (
        <React.Fragment>
			{this.props.ocultarInput === false ? (
				<RadioGroup
					className="form-control d-inline-flex w-auto"
					style={{ display: 'inline-flex', width: 'auto' }}
					selectedValue={this.props.atributo[this.valueKey]}
					onChange={this.handleChangeAndUpdateFather}
					>
						{checks.map((option, index) =>
						<label key={index} className="p-1">
							<Radio disabled={this.props.disabled} key={option.text} value={option.text}/>
							<p>{option.text}</p>
						</label>
						)}
				</RadioGroup>
			) : (
				<input
				disabled={this.props.disabled}
				type="text"
				className="form-control"
				value={this.props.atributo[this.valueKey]}
				onChange={this.handleInputChange}
			/>
			)}
						
        </React.Fragment>
      )
  }
}

export default InstanciaSiNo;
